<script setup lang="ts">
    import Paginate from 'vuejs-paginate-next';
    const emit = defineEmits(['click']);

    const props = defineProps<{
        pagination: Object;
    }>();
    const page = ref(props.pagination.currentPage);

    const clicked = (page: number) => {
        emit('click', page);
    };
</script>

<template>
    <paginate
        v-if="pagination.lastPage > 1"
        v-model="page"
        :page-count="pagination.lastPage"
        :click-handler="clicked"
        :prev-text="$t('pagination.prev')"
        :next-text="$t('pagination.next')"
        container-class="flex justify-center w-full p-4"
        page-link-class="px-4 py-2 mx-1 text-branding-rich-black transition-all rounded cursor-pointer bg-branding-smoke hover:bg-branding-light-grey"
        prev-link-class="px-4 py-2 mx-1 text-branding-rich-black transition-all rounded cursor-pointer bg-branding-smoke hover:bg-branding-light-grey"
        next-link-class="px-4 py-2 mx-1 text-branding-rich-black transition-all rounded cursor-pointer bg-branding-smoke hover:bg-branding-light-grey"
        active-class="!bg-branding-brand-yellow !text-branding-rich-black hover:!bg-branding-mustard"
        :no-li-surround="true"
        :hide-prev-next="true"
    />
</template>
